import React, { useEffect, useState } from "react";
import { Badge, Calendar, Spin } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";
// import dayjs from "dayjs";

const CRMCalendar = () => {
  const [calendarTasks, setCalendarTasks] = useState({});
  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");

  const staffId = userDetails?.staffid || 48;

  useEffect(() => {
    fetchCalendarTasks();
  }, []);

  const fetchCalendarTasks = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}dashboard/GetMyCalendarTasks?staffid=${staffId}&fromDate=2024-01-01&toDate=2026-08-26`,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch calendar tasks");
      }

      const data = await response.json();

      if (data?.Status && data?.ResultData) {
        setCalendarTasks(data.ResultData);
      } else {
        setCalendarTasks({});
      }
    } catch (error) {
      console.error("Error fetching calendar tasks:", error);
      setCalendarTasks({});
    } finally {
      setLoading(false);
    }
  };

  // Convert API status to Ant Design Badge status
  const getBadgeStatus = (status) => {
    switch (Number(status)) {
      case 0:
        return "default";

      case 1:
        return "success";

      case 2:
        return "processing";

      case 3:
        return "warning";

      case 4:
        return "error";

      default:
        return "default";
    }
  };

  const dateCellRender = (value) => {
    const dateKey = value.format("YYYY-MM-DD");

    const listData = calendarTasks[dateKey] || [];

    if (listData.length === 0) {
      return null;
    }

    return (
      <ul className="events">
        {listData.map((item) => (
          <li key={item.id}>
            <Badge status={getBadgeStatus(item.status)} text={item.title} />
          </li>
        ))}
      </ul>
    );
  };

  const monthCellRender = (value) => {
    const monthPrefix = value.format("YYYY-MM");

    const monthTasks = Object.entries(calendarTasks)
      .filter(([date]) => date.startsWith(monthPrefix))
      .flatMap(([, tasks]) => tasks);

    if (monthTasks.length === 0) {
      return null;
    }

    return (
      <div className="notes-month">
        <section>{monthTasks.length}</section>
        <span>Tasks</span>
      </div>
    );
  };

  const cellRender = (current, info) => {
    if (info.type === "date") {
      return dateCellRender(current);
    }

    if (info.type === "month") {
      return monthCellRender(current);
    }

    return info.originNode;
  };

  return (
    <Spin spinning={loading}>
      <Calendar cellRender={cellRender} mode="month" />
    </Spin>
  );
};

export default CRMCalendar;
